import {
  PlayerCommunityEvent,
  CommunityEventMilestone,
  CommunityJackpotEvents,
} from './communityJackpot.types';

const sortMilestones = (milestones: CommunityEventMilestone[]) =>
  [...milestones].sort((m1, m2) => m1.threshold - m2.threshold);

export const parseEvent = ({ milestones, ...rest }: PlayerCommunityEvent) => ({
  ...rest,
  milestones: sortMilestones(milestones),
});

export const parseEvents = (events: PlayerCommunityEvent[]) =>
  events.map(parseEvent);

export const checkIfCommunityJackpotVisible = (
  playerRewards: CommunityJackpotEvents['playerCommunityEventRewards'],
  playerEvent?: PlayerCommunityEvent,
) => {
  if (!playerEvent) {
    return false;
  }

  const startDate = new Date(playerEvent.startDate);
  const endDate = new Date(playerEvent.endDate);
  const currentDate = new Date();
  const showUntilDate = playerEvent.showUntil
    ? new Date(playerEvent.showUntil)
    : (() => {
        const date = new Date(endDate);

        date.setDate(date.getDate() + 3);

        return date;
      })();

  return (
    (startDate <= currentDate && currentDate <= showUntilDate) ||
    playerRewards.length > 0
  );
};
